
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class MaterialInGrid extends _Ext.GridBase<MaterialInRow, any> {
        protected getColumnsKey() { return 'Purchase.MaterialIn'; }
        protected getDialogType() { return MaterialInDialog; }
        protected getIdProperty() { return MaterialInRow.idProperty; }
        protected getInsertPermission() { return MaterialInRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialInRow.localTextPrefix; }
        protected getService() { return MaterialInService.baseUrl; }
        //private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row);
            super.onClick(e, row, cell);
        }

        protected addButtonClick() {
            
            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[38].AutoPosting;
            var voucherNo = FormatHelper.GetVoucherNo(38);


            this.editItem(<MaterialInRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 38,
                AutoPosting: autoposting,
                TransDate: now.toDateString(),
                
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}